import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './AppRouter';
import { initPostHog } from './lib/posthog';
import { afterBlockingWindow } from './lib/after-blocking-window';
import './i18n';
import { SUPPORTED_LOCALES } from './i18n';
import './global.css';

// DEV-12125: initPostHog dynamically imports posthog-js (off the critical path).
// DEV-12444: requestIdleCallback fired inside the 3.5s bench settle and parsed
// the vendor-analytics chunk as a long task. Same window as Unicorn/CMS — wait
// for scroll or 4s. Swallow a failed chunk load (offline / ad-blocker).
afterBlockingWindow(() => { initPostHog().catch(() => {}); });

// DEV-11204: locale-prefixed landing URLs (/es/about, /de/pricing, …). EN +
// x-default live at the bare path; es/de/fr/zh are served from a `/<locale>`
// prefix with their own prerendered HTML. Mount the route tree under the
// detected prefix so the existing routes resolve unchanged — `/es/about`
// becomes the `/about` route (rendered in Spanish; i18n reads the same prefix).
// Bare paths keep `basename === undefined`, so existing behavior is untouched.
function localeBasename(): string | undefined {
  const seg = window.location.pathname.split('/')[1];
  return seg !== 'en' && (SUPPORTED_LOCALES as readonly string[]).includes(seg) ? `/${seg}` : undefined;
}

const Root = () => (
  <BrowserRouter basename={localeBasename()}>
    <AppRouter />
  </BrowserRouter>
);

createRoot(document.getElementById('root')!).render(<Root />);
